import { render, staticRenderFns } from "./contenido.vue?vue&type=template&id=187f077a"
import script from "./contenido.vue?vue&type=script&lang=js"
export * from "./contenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports